import CoursePlanFeedbackEvent from './CoursePlanFeedbackEvent';
export default CoursePlanFeedbackEvent;
